/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useState, useEffect } from 'react';
import radio_on from '../../../../img/create_ads/radio_on.svg'
import radio_off from '../../../../img/create_ads/radio_off.svg'
function CreateAdsRadioGroup(props) {
    const [selectedIndex, setSelectedIndex] = useState(0)
   
    useEffect(() => {
        for (let index = 0; index < props.items.length; index++) {
            const element = props.items[index]
            if (element == props.selectedItem){
                setSelectedIndex(index)
                break
            }
        }
    }, [props.selectedItem])
    const itemSelected = (item, index) => {
        props.setSelectedItem(item, index)
    }
    return (
        <div className="relative">
            {props.items.length > 0 && props.items.map((item, index) => (
                <div onClick={() => itemSelected(item, index)} className="hover create_ads_radio_container" key={index}>
                    <img alt='' className="create_ads_radio_icon" src={selectedIndex == index ? radio_on : radio_off}/>
                    <div>
                        <div style={{textAlign : 'left'}} className="create_ads_radio_title">{item}</div>
                        {props.prices && <div style={{textAlign : 'left'}} className='create_ads_prices_desc_o'>{props.prices[index]}</div>}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default CreateAdsRadioGroup;
